export enum TrackingType {
  All = 'All',
  AVL = 'AVL',
  Mobile = 'MOBILE',
  Empty = 'EMPTY'
}
